export enum EAuthenticationProviderSignInFlowStates {
  UNDEFINED = 'undefined',
  STARTED = 'started',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
  INVALID = 'invalid',
}
